import { render, staticRenderFns } from "./DialogDetailCriminalProcess.vue?vue&type=template&id=03b27dc3"
import script from "./DialogDetailCriminalProcess.vue?vue&type=script&lang=js"
export * from "./DialogDetailCriminalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports